import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { SuperHttpClientProvider } from '@app/core/http';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private _data$: ReplaySubject<any[]> = new ReplaySubject(1);

  constructor(private $http: SuperHttpClientProvider) {
    this._data$.next([]);
  }

  public get data$(): Observable<any[]> {
    return this._data$.asObservable();
  }

  public setData(data: any[]) {
    this._data$.next(data);
  }

  public associateClient(idUser: number, idClient: number) {
    return this.$http.default.put('/admin/setClient', { idUser, idClient });
  }

  public removeClient(idUser: number, idClient: number) {
    return this.$http.default.delete(
      `/admin/removeClient?idUser=${idUser}&idClient=${idClient}`
    );
  }
}
